import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"
import {
  useGetMyCompletedQuery,
  useGetMyProgressQuery,
  useGetQuestsQuery
} from "@/store/apis/questsAPI"
import { Spinner } from "@/ui/Spinner"
import styles from "./QuestsList.module.scss"
import { filterQuestsByLanguage } from "./helpers"
import { QuestCard } from "./ui"

export const QuestsList: FC = () => {
  const { t, i18n } = useTranslation()
  const { data: questsRes, isLoading } = useGetQuestsQuery()
  const { data: completedRes } = useGetMyCompletedQuery()
  const { data: progressRes } = useGetMyProgressQuery()

  const quests = questsRes ?? []
  const completed = completedRes?.items ?? []
  const progress = progressRes?.progress ?? {}

  const visibleQuests = useMemo(
    () => filterQuestsByLanguage(quests, i18n.language),
    [quests, i18n.language]
  )

  const claimedCount = completed.filter((c) => c.isClaimed).length
  const totalCount = visibleQuests.length

  const completedByQuestId = useMemo(
    () =>
      new Map(completed.filter((c) => c.quest).map((c) => [c.quest._id, c])),
    [completed]
  )

  return (
    <section className={styles.QuestsList}>
      <div className={styles.QuestsList_title}>{t("quests.list.title")}</div>
      <div className={styles.QuestsList_subtitle}>
        {t("quests.list.claimedOfTotal", {
          claimed: claimedCount,
          total: totalCount
        })}
      </div>
      <div className={styles.QuestsList_items}>
        {isLoading && !quests.length && <Spinner />}
        {visibleQuests.map((q) => (
          <QuestCard
            quest={q}
            completed={completedByQuestId.get(q._id)}
            progressMet={progress[q._id] ?? false}
            key={q._id}
          />
        ))}
      </div>
    </section>
  )
}
